import { convertFirebaseTimestampToDate } from '@creator/ui/utils/date-utils';
import { getComment } from './comments';

export const getBasicCommentEventData = (commentId: string) => {
    const comment = getComment(commentId);
    if (!comment) throw new Error(`[comments/analytics] comment with id ${commentId} not found`);

    const { postId, publisherName, publisherProfileName, createdAt, tokenName } = comment;
    return {
        postId: postId,
        tokenName: tokenName,
        commenterId: publisherName,
        commenter: publisherProfileName || publisherName,
        originalPublishDate: convertFirebaseTimestampToDate(createdAt).toISOString(),
    };
};
